// Human-readable funnel_step names for the onboarding flow, keyed by the
// account-flow state-machine step. Single source of truth so the
// user_start_onboarding event always carries a proper, complete funnel_step
// value (no blanks). Keep in sync with `stepsToTrack` in AccountFlow.
export const funnelStepNames: Record<string, string> = {
  'signUp.stats': 'metrics',
  'signUp.pickAccountMethod': 'account_method',
  'signUp.emailAccountCreation': 'email_account_creation',
  'signUp.setUp': 'setup',
  'subscription.freePurchase': 'free_purchase',
  'subscription.choosePlan': 'choose_plan',
  'subscription.pay': 'payment',
}
